// extracted by mini-css-extract-plugin
module.exports = {"section":"IngredientSection_section__QWEW8","link-wrapper":"IngredientSection_link-wrapper__axo_b","link":"IngredientSection_link__zlTp1"};